(() => {
  'use strict';

  const config = document.currentScript;
  if (!config || config.dataset.kmcClubLinkTracking !== 'true') return;
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.__kmcClubLinkConversion) return;
  window.__kmcClubLinkConversion = true;

  const formId = '1074535';
  const pixelId = '356397668561834';
  const markerKey = 'kmc:club-link:application-intent:v1';
  const sourceSuffix = '/pages/club-link';
  const successSuffix = '/pages/club-link-application-received';
  const sourceParameter = 'club_link_form';
  const maxAge = 30 * 60 * 1000;
  const path = window.location.pathname.replace(/\/$/, '');
  const matchesPath = (value, suffix) => value === suffix || new RegExp('^/[a-z]{2}(?:-[a-z]{2})?' + suffix + '$', 'i').test(value);
  const removeMarker = () => {
    try { window.sessionStorage.removeItem(markerKey); } catch (_) {}
  };

  if (matchesPath(path, sourceSuffix)) {
    removeMarker();
    const roots = new WeakSet();
    const captureIntent = (event) => {
      if (!event.isTrusted || !event.target || event.target.tagName !== 'FORM') return;
      try {
        if (!window.crypto || typeof window.crypto.randomUUID !== 'function') return;
        window.sessionStorage.setItem(markerKey, JSON.stringify({
          version: 1,
          formId,
          sourcePath: path,
          createdAt: Date.now(),
          eventId: 'club-link-' + window.crypto.randomUUID()
        }));
      } catch (_) {}
    };
    const bind = () => {
      const container = document.querySelector('[data-form-root="true"][data-forms-id="forms-root-' + formId + '"]');
      if (!container) return;
      container.querySelectorAll('shopify-forms-embed').forEach((host) => {
        const root = host.shadowRoot;
        if (!root || roots.has(root)) return;
        roots.add(root);
        root.addEventListener('submit', captureIntent, true);
      });
    };
    const observer = new MutationObserver(bind);
    observer.observe(document.documentElement, { childList: true, subtree: true });
    if (window.customElements) window.customElements.whenDefined('shopify-forms-embed').then(bind);
    window.addEventListener('pageshow', (event) => { if (event.persisted) removeMarker(); });
    bind();
    return;
  }

  if (!matchesPath(path, successSuffix)) return;
  const query = new URLSearchParams(window.location.search);
  if (query.get(sourceParameter) !== formId) return;

  let marker;
  try { marker = JSON.parse(window.sessionStorage.getItem(markerKey)); } catch (_) { return; }
  if (!marker || marker.version !== 1 || marker.formId !== formId ||
      typeof marker.eventId !== 'string' || !/^club-link-[0-9a-f-]{36}$/i.test(marker.eventId) ||
      typeof marker.createdAt !== 'number' || !Number.isFinite(marker.createdAt) ||
      Date.now() < marker.createdAt || Date.now() - marker.createdAt > maxAge ||
      !matchesPath(marker.sourcePath, sourceSuffix)) return;

  try {
    const referrer = new URL(document.referrer);
    if (referrer.origin !== window.location.origin || referrer.pathname.replace(/\/$/, '') !== marker.sourcePath) return;
    const navigation = window.performance.getEntriesByType('navigation')[0];
    if (!navigation || navigation.type !== 'navigate') return;
    window.sessionStorage.removeItem(markerKey);
  } catch (_) { return; }

  let sent = false;
  let stopped = false;
  let privacyRequested = false;
  const consentAllowed = () => {
    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!privacy &&
        privacy.analyticsProcessingAllowed() === true &&
        privacy.marketingAllowed() === true &&
        privacy.saleOfDataAllowed() === true;
    } catch (_) { return false; }
  };
  const sendIfReady = () => {
    if (sent || stopped) return;
    const age = Date.now() - marker.createdAt;
    if (age < 0 || age > maxAge) {
      cleanup();
      return;
    }
    if (!consentAllowed()) {
      const shopify = window.Shopify;
      const privacy = shopify && shopify.customerPrivacy;
      const privacyReady = privacy &&
        typeof privacy.analyticsProcessingAllowed === 'function' &&
        typeof privacy.marketingAllowed === 'function' &&
        typeof privacy.saleOfDataAllowed === 'function';
      if (!privacyReady && !privacyRequested && shopify && typeof shopify.loadFeatures === 'function') {
        privacyRequested = true;
        try {
          shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
            if (!error) sendIfReady();
          });
        } catch (_) {}
      }
      return;
    }
    if (typeof window.fbq !== 'function') return;
    sent = true;
    cleanup();
    window.fbq('trackSingle', pixelId, 'SubmitApplication', {}, { eventID: marker.eventId });
  };
  const cleanup = () => {
    stopped = true;
    document.removeEventListener('visitorConsentCollected', sendIfReady);
    document.removeEventListener('load', sendIfReady, true);
    window.removeEventListener('load', sendIfReady);
    window.removeEventListener('pagehide', cleanup);
  };
  document.addEventListener('visitorConsentCollected', sendIfReady);
  document.addEventListener('load', sendIfReady, true);
  window.addEventListener('load', sendIfReady);
  window.addEventListener('pagehide', cleanup);
  sendIfReady();
})();
